<template>
  <div class="terms-content" v-html="compiled"></div>
</template>

<script>
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true
})

export default {
  name: 'TermsContent',
  data() {
    return {
      raw: ''
    }
  },
  computed: {
    compiled() {
      return this.raw ? md.render(this.raw) : ''
    }
  },
  async mounted() {
    const locale = (this.$i18n?.locale || 'zh-TW').toLowerCase()

    const map = {
        'zh-tw': 'zh-TW',
        'zh': 'zh-TW',
        'en': 'en-US',
        'en-us': 'en-US'
    }

    const file = map[locale] || 'zh-TW'
    const res = await fetch(`/terms/${file}.md`, { cache: 'no-store' })
    this.raw = await res.text()
    }
}
</script>

<style scoped>
.terms-content{
  line-height: 1.8;
  color: #222;
}
.terms-content h1,
.terms-content h2,
.terms-content h3{
  margin-top: 18px;
  font-weight: 800;
}
.terms-content h4{
  margin-top: 14px;
  font-weight: 700;
}
.terms-content ul{
  padding-left: 1.2em;
}
</style>